import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import { registerAuthHook } from './guards/auth'
import { registerProgressHooks } from './guards/progress'

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

registerProgressHooks(router)
if (process.env.NODE_ENV !== 'development') {
  registerAuthHook(router)
}
export { router }
